var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Axios from "axios";
import { metrics } from "../lib/tracking";
export default class Charon {
    constructor() {
        this.serverURL = process.env.CHARON_URL + "";
        this.tileURL = this.serverURL + "/tile/?x={x}&y={y}&z={z}";
    }
    getStyle() {
        return fetch(this.serverURL + "/style").then((r) => r.json());
    }
    forwardGeocoding(query) {
        return __awaiter(this, void 0, void 0, function* () {
            metrics.addGeocoding();
            const response = yield Axios.get(this.serverURL + `/geocoding/forward/?query=${query}`, {});
            if (response.status === 200) {
                return response.data;
            }
        });
    }
    forwardGeocoding2(query) {
        return __awaiter(this, void 0, void 0, function* () {
            metrics.addGeocoding();
            const response = yield Axios.get(`http://nominatim.openstreetmap.org/?format=json&addressdetails=1&q=${query}&format=geojson&limit=1`, {});
            if (response.status === 200) {
                return response.data;
            }
        });
    }
    reverseGeocoding(lat, lon) {
        return __awaiter(this, void 0, void 0, function* () {
            metrics.addGeocoding();
            const url = this.serverURL + `/geocoding/reverse/?lat=${lat}&lon=${lon}`;
            const response = yield Axios.get(url, {});
            if (response.status === 200) {
                const json = response.data;
                return json;
            }
            return undefined;
        });
    }
}
